export function hasReceivedNewProps(oldProps, newProps, objects) {
	let result = false;

	objects.forEach(o => {
		if (newProps[o]) {
			if (typeof newProps[o] === 'object') {
				const newId = newProps[o] ? newProps[o].id : 0;
				const oldId = oldProps[o] ? oldProps[o].id : 0;
				result = result || (newId !== 0 && newId !== oldId);
			} else {
				result = result || newProps[o] !== oldProps[o];
			}
		}
	});

	return result;
}

export function setModalOpen(show) {
	const current = document.body.className;
	if (show) {
		if (current.indexOf('modal-open') < 0) {
			document.body.className = `${current} modal-open`;
		}
	} else {
		document.body.className = current.replace(' modal-open', '');
	}
}
